import type { RotaryKiln } from '../../../types/reports.js';
import { formatMeasurementDateForTitle } from './KilnMeasurementCard.js';

// Phase 28 (D-14): "-- stillgelegt am {DD.MM.JJJJ}"-Zusatz fuer den Ofentitel. Nur wenn der Ofen
// laut Stammdaten ein activeUntil im GENAU diesem Berichtsjahr traegt -- ein Stilllegungsdatum in
// einem spaeteren Jahr hiesse, der Ofen war in DIESEM Berichtsjahr durchgehend in Betrieb, und der
// Zusatz waere falsch. Datumsformat wiederverwendet aus KilnMeasurementCard.tsx (Wiedererkennung
// statt Neuerfindung).
function stilllegungSuffix(kiln: RotaryKiln, reportingYear?: string): string {
  const activeUntil = kiln.plantKiln?.activeUntil;
  if (!activeUntil || !reportingYear) return '';
  if (activeUntil.slice(0, 4) !== reportingYear) return '';
  return ` — stillgelegt am ${formatMeasurementDateForTitle(activeUntil)}`;
}

/**
 * Titel einer Ofenkarte, gemeinsam fuer die Reiter Drehoefen und Frachtenberechnung: Ofenname
 * (Rueckfall "Drehofen N") samt Stilllegungs-Zusatz. Phase 28 (D-23): `kilnName` ist nicht
 * editierbar, der Titel braucht deshalb kein `form.watch`.
 */
export function kilnTitle(kiln: RotaryKiln, kilnIdx: number, reportingYear?: string): string {
  const name = kiln.kilnName || `Drehofen ${kilnIdx + 1}`;
  return `${name}${stilllegungSuffix(kiln, reportingYear)}`;
}
